<!-- Mobile Backdrop Overlay -->
<div class="mobile-backdrop" #mobileBackdrop *ngIf="isOpen" (click)="onCancel()"></div>

<div
  class="dropdown-menu"
  #dropdownMenu
  *ngIf="isOpen"
  (click)="$event.stopPropagation()"
  [class.custom-width]="isCustomSelected()"
>
  <div class="dropdown-options" #dropdownOptions [class.with-custom]="isCustomSelected()">
    <div
      class="radio-option"
      *ngFor="let option of periodOptions; trackBy: trackByValue"
      (click)="onPeriodSelect(option.value)"
    >
      <div class="radio-button" [class.selected]="selectedOption === option.value">
        <div class="radio-inner" *ngIf="selectedOption === option.value"></div>
      </div>
      <span class="radio-label" [class.selected]="selectedOption === option.value">{{
        option.label
      }}</span>
    </div>
  </div>

  <!-- Custom Date Range Inputs (outside scrollable options so they stay reachable) -->
  <div
    class="custom-date-range"
    #customDateRange
    *ngIf="isCustomSelected()"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (mouseup)="$event.stopPropagation()"
  >
    <div class="date-input-group" (click)="$event.stopPropagation()">
      <div class="date-input-container" (click)="$event.stopPropagation()">
        <label class="date-label">Start Date</label>
        <div class="date-input-wrapper" (click)="$event.stopPropagation()">
          <app-custom-date-picker
            [(ngModel)]="tempCustomRange.startDate"
            (dateTimeChange)="onStartDateChange($event)"
            placeholder="Start date"
            [showTime]="false"
            [showFooterButtons]="false"
            [allowPastDates]="true"
            [fixedOverlay]="true"
            [maxDate]="tempCustomRange.endDate"
          >
          </app-custom-date-picker>
        </div>
      </div>

      <div class="date-input-container" (click)="$event.stopPropagation()">
        <label class="date-label">End Date</label>
        <div class="date-input-wrapper" (click)="$event.stopPropagation()">
          <app-custom-date-picker
            [(ngModel)]="tempCustomRange.endDate"
            (dateTimeChange)="onEndDateChange($event)"
            placeholder="End date"
            [showTime]="false"
            [showFooterButtons]="false"
            [allowPastDates]="true"
            [fixedOverlay]="true"
            dropdownAlign="right"
            [minDate]="tempCustomRange.startDate"
          >
          </app-custom-date-picker>
        </div>
      </div>
    </div>

    <p class="date-range-error" *ngIf="dateRangeError">{{ dateRangeError }}</p>
  </div>

  <!-- Action Buttons - Only show for Custom Date Range -->
  @if (showCustomFooter) {
    <app-modal-footer-actions
      footerClass="modal-footer--compact"
      secondaryText="Clear"
      cancelText="Cancel"
      [primaryText]="applyButtonLabel"
      [showSecondary]="true"
      [showPrimary]="true"
      [primaryDisabled]="primaryDisabled"
      (secondaryClick)="onClear()"
      (cancelClick)="onCancel()"
      (primaryClick)="onApply()"
    />
  }
</div>
